
<script>

import { defineComponent } from 'vue'

import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap

import Editor from '@tinymce/tinymce-vue'

/* Import TinyMCE */
import tinymce from 'tinymce';

/* Default icons are required for TinyMCE 5.3 or above */
import 'tinymce/icons/default';

/* A theme is also required */
import 'tinymce/themes/silver';

/* Import the skin */
import 'tinymce/skins/ui/oxide/skin.css';

/* Import plugins */
import 'tinymce/plugins/advlist';
import 'tinymce/plugins/code';
import 'tinymce/plugins/emoticons';
import 'tinymce/plugins/emoticons/js/emojis';
import 'tinymce/plugins/link';
import 'tinymce/plugins/lists';
import 'tinymce/plugins/table';


//general functions
import MixinGeneralFunct from '@/mixins/GeneralFunctions';


import OneDocumentToArticle from './modalsEditor/documentToArticle'
import OnePhotoToArticle from './modalsEditor/photoToArticle'
import OneGalleryToArticle from './modalsEditor/galleryToArticle'
import PluginLibraryToArticle from './modalsEditor/libraryPluginToArticle'
import PluginGalleryToArticle from './modalsEditor/galleryPluginToArticle'


//data
import { getDocumentPreview } from '@/services/serviceDocument';
import { getPhotoPreview, getPhotosPreviewByGallery } from '@/services/servicePhoto';

export default defineComponent({
  name: 'ArticleTextEditor',
  mixins: [ MixinGeneralFunct ],
  components: {
		OneDocumentToArticle
		,OnePhotoToArticle
		,OneGalleryToArticle
		,PluginGalleryToArticle
		,PluginLibraryToArticle

    ,'editor': Editor
	},
	data() {
    const TINYloadModalFormSelectPhotoToArticle = this.loadModalFormSelectPhotoToArticle;
		const TINYloadModalFormSelectGalleryToArticle = this.loadModalFormSelectGalleryToArticle;
		const TINYloadModalFormSelectGalleryToArticlePlugin = this.loadModalFormSelectGalleryToArticlePlugin;
		const TINYloadModalFormSelectLibraryToArticlePlugin = this.loadModalFormSelectLibraryToArticlePlugin;
		const TINYloadModalFormSelectDocumentToArticle = this.loadModalFormSelectDocumentToArticle;
		return {
      obsahClanku:""
      ,workContent:{}
	,initObj: {

        setup: function (editor) {
				
          editor.ui.registry.addButton('myPhotoButton', {
            text: 'Obrázok do textu',
            icon: 'image',
            onAction: function () {
              TINYloadModalFormSelectPhotoToArticle();
            }
          });
          
          editor.ui.registry.addButton('myGalleryButton', {
            text: 'Galéria do textu',
            icon: 'image',
            onAction: function () {
              TINYloadModalFormSelectGalleryToArticle();
            }
          });
          
          editor.ui.registry.addButton('myGalleryPluginButton', {
            text: 'Galéria ako plugin',
            icon: 'image',
            onAction: function () {
              TINYloadModalFormSelectGalleryToArticlePlugin();
            }
          });
          
          editor.ui.registry.addButton('myLibraryPluginButton', {
            text: 'Knižnica ako plugin',
            icon: 'image',
            onAction: function () {
              TINYloadModalFormSelectLibraryToArticlePlugin();
            }
          });
          
          editor.ui.registry.addButton('myDocumentButton', {
            text: 'Dokument do textu',
            icon: 'image',
            onAction: function () {
              TINYloadModalFormSelectDocumentToArticle();
            }
          });
          
        }           
				,relative_urls: false
				,convert_urls: false
				,remove_script_host:false
				,height:400
				,entity_encoding : "raw" 
				,language:'sk'
				,extended_valid_elements: 'i[class]'
				,iconfonts_selector: '.fa, .fab, .fal, .far, .fas, .glyphicon'
        ,plugins: 'wordcount, advlist, autolink, link, image, lists, charmap, print, preview, hr, anchor, pagebreak, spellchecker, searchreplace, visualblocks, visualchars, code, fullscreen, insertdatetime, media, nonbreaking, save, table, directionality, emoticons, template, paste'
        ,toolbar: 'undo redo | copy cut paste | formatselect | bold italic underline backcolor forecolor | link image table | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat | myPhotoButton myGalleryButton myGalleryPluginButton myLibraryPluginButton myDocumentButton'

			}

      //form
		/*	article:[],
			gallery:[],
			library:[],
			docs:[],
			photos:[],
			optionsGalleries:[],
			optionsLibraries:[],
			selectedGallery:'',
			selectedLibrary:'',
			selectedComponentId:''
*/
      //editorModals
      ,modalDocToArticleID:''
      ,docToArticleMODAL:{}

      ,modalGalleryToArticleID:''
      ,galleryToArticleMODAL:{}

      ,modalPhotoToArticleID:''
      ,photoToArticleMODAL:{}

		,modalGalleryPluginToArticleID:''
      ,galleryPluginToArticleMODAL:{}

      ,modalLibraryPluginToArticleID:''
      ,libraryPluginToArticleMODAL:{}
		}
	},
  props: {
	'auth':Object, 'secData':Object, 'content': String
  },
  emits: ["content","changeContent"],
  mounted () {
    this.obsahClanku = this.content;
    this.workContent = this.content;
    
    this.modalDocToArticleID = `modal${this.getRandomInt(999999999)}`;
    this.modalGalleryToArticleID = `modal${this.getRandomInt(999999999)}`;
    this.modalPhotoToArticleID = `modal${this.getRandomInt(999999999)}`;
    this.modalGalleryPluginToArticleID = `modal${this.getRandomInt(999999999)}`;
    this.modalLibraryPluginToArticleID = `modal${this.getRandomInt(999999999)}`;
  },
  
	methods: {

		loadContent:function(){
			this.workContent=this.obsahClanku;
			this.$emit('changeContent', this.workContent)
		},


		//modal box select photos to article
		loadModalFormSelectPhotoToArticle:function(){
			this.photoToArticleMODAL = new bootstrap.Modal(document.getElementById(this.modalPhotoToArticleID), {backdrop:'static'})
			this.photoToArticleMODAL.show();
		},

		//modal box select gallery to article
		loadModalFormSelectGalleryToArticle:function(){
			this.galleryToArticleMODAL = new bootstrap.Modal(document.getElementById(this.modalGalleryToArticleID), {backdrop:'static'})
			this.galleryToArticleMODAL.show();
		},

		//modal box select gallery to article Plugin
		loadModalFormSelectGalleryToArticlePlugin:function(){
			this.galleryPluginToArticleMODAL = new bootstrap.Modal(document.getElementById(this.modalGalleryPluginToArticleID), {backdrop:'static'})
			this.galleryPluginToArticleMODAL.show();
		},
		
		//modal box select library to article Plugin
		loadModalFormSelectLibraryToArticlePlugin:function(){
			this.libraryPluginToArticleMODAL = new bootstrap.Modal(document.getElementById(this.modalLibraryPluginToArticleID), {backdrop:'static'})
			this.libraryPluginToArticleMODAL.show();
		},

		//modal box select document to article
		loadModalFormSelectDocumentToArticle:function(){
			this.docToArticleMODAL = new bootstrap.Modal(document.getElementById(this.modalDocToArticleID), {backdrop:'static'})
			this.docToArticleMODAL.show();
		},


		//hotovo 
		//zapise vybranu galeriu do clanku
		loadGalleryToArticlePlugin:function(galleryId){
			
			if(galleryId){
				
				var x = "";
				x +="{loadPhotoGallery["+galleryId+"]}";
			
				tinymce.activeEditor.insertContent(x);
				
				this.galleryPluginToArticleMODAL.hide();
				
			}
		},

		//hotovo	 
		//zapise vybranu kniznicu do clanku
		loadLibraryToArticlePlugin:function(libraryId){
			
			if(libraryId){
				
				var x = "";
				x +="{loadDocumentLibrary["+libraryId+"]}";
			
				tinymce.activeEditor.insertContent(x);

				this.libraryPluginToArticleMODAL.hide();
				
			}
		},



		//zapise vybrany dokument do clanku
		loadDocumentToArticleUrl:function(documentId){

			getDocumentPreview({documentId:documentId}).then(response => {
				if(!response.statusText){
					var currData='<a href='+response.document.url+'>'+response.document.title+'</a>';
					tinymce.activeEditor.insertContent(currData);
					this.docToArticleMODAL.hide();
				}else{
					this.toast.error(`${response.statusText} ${response.status}`);
				}
			});
		},

		
		//zapise vybranu galeriu do clanku
		loadGalleryToArticleUrl:function(galleryId){
			getPhotosPreviewByGallery({galleryId:galleryId}).then(response => {
				if(!response.statusText){
					console.log(response)
					var x = "";
					for(var i=0;i<response.photos.length;i++){
						x +="<div class='crop_gallery2'><a class='fancybox' data-fancybox='gallery' href='"+response.photos[i].photoUrl+"'><img src='" + response.photos[i].photoUrlThumb + "'/></a></div>";
					}
					tinymce.activeEditor.insertContent(x);

					this.galleryToArticleMODAL.hide();

				}else{
					this.toast.error(`${response.statusText} ${response.status}`);
				}
			});
		
		},

			
		//zapise vybranu fotku do clanku
		loadPhotoToArticleUrl:function(photoId){
			
			getPhotoPreview({photoId:photoId}).then(response => {
				if(!response.statusText){
					console.log(response)
					var currData='<a class="fancybox" data-fancybox="gallery" href="'+response.photo.photoUrl+'"><img class="img-fluid" src="' + response.photo.photoUrlThumb + '" /></a>';
					tinymce.activeEditor.insertContent(currData);

					this.photoToArticleMODAL.hide();

				}else{
					this.toast.error(`${response.statusText} ${response.status}`);
				}
			});

		},


			
	},
	
	watch: {
    
	},
	
	created() {

	}
  
})
</script>

<template>
  <div>

	

	<div class="col-12">

		<editor tinymce-script-src="tinymce/tinymce.min.js" v-model="obsahClanku" :init="initObj"  @selectionChange="loadContent" />

		<OneDocumentToArticle :auth="auth" :secData="secData" :modalId="modalDocToArticleID" @changeAfterSelect="loadDocumentToArticleUrl" :modalObject="docToArticleMODAL"></OneDocumentToArticle>

		<OneGalleryToArticle :auth="auth" :secData="secData" :modalId="modalGalleryToArticleID" @changeAfterSelect="loadGalleryToArticleUrl" :modalObject="galleryToArticleMODAL"></OneGalleryToArticle>
		
		<OnePhotoToArticle :auth="auth" :secData="secData" :modalId="modalPhotoToArticleID" @changeAfterSelect="loadPhotoToArticleUrl" :modalObject="photoToArticleMODAL"></OnePhotoToArticle>
		
		<PluginLibraryToArticle :auth="auth" :secData="secData" :modalId="modalLibraryPluginToArticleID" @changeAfterSelect="loadLibraryToArticlePlugin" :modalObject="libraryPluginToArticleMODAL"></PluginLibraryToArticle>

		<PluginGalleryToArticle :auth="auth" :secData="secData" :modalId="modalGalleryPluginToArticleID" @changeAfterSelect="loadGalleryToArticlePlugin" :modalObject="galleryPluginToArticleMODAL"></PluginGalleryToArticle>
	</div>

  </div>
</template>